import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useSearchService } from '@/services/request.service/request-service-context';
import { queryKeys } from '@/utils/react-query/query-keys';

/**
 * React Query hook for fetching environments using the OSS Request Service
 * @returns UseQueryResult containing environments data, loading state, and error handling
 */
export function useGetEnvironments(): UseQueryResult<string[]> {
    const searchService = useSearchService();

    return useQuery({
        queryKey: queryKeys.environment.lists(),
        queryFn: async () => {
            try {
                const response = await searchService.getEnvironments();
                return response.environments;
            } catch (error) {
                console.error('[useGetEnvironments] queryFn error:', error);
                throw error;
            }
        },
    });
}
